export let TypeRouter;

(function (TypeRouter) {
  TypeRouter["ReqRouterPush"] = "REQ.ROUTER.PUSH";
  TypeRouter["ReqRouterPop"] = "REQ.ROUTER.POP";
  TypeRouter["ReqRouterOpen"] = "REQ.ROUTER.OPEN";
  TypeRouter["ReqRouterClose"] = "REQ.ROUTER.CLOSE";
  TypeRouter["ReqRouterReplace"] = "REQ.ROUTER.REPLACE";
  TypeRouter["ReqRouterPrefetch"] = "REQ.ROUTER.PREFETCH";
  TypeRouter["ReqRouterStyle"] = "REQ.ROUTER.STYLE";
})(TypeRouter || (TypeRouter = {}));